const Header = ({
  active,
  setActive,
  count,
}: {
  active: any;
  setActive: any;
  count: number;
}) => {
  return (
    <div className="ml-[20px] mr-[14px] mt-[20px] border-[1px] border-[#eeeeee] p-3 rounded-[10px]">
      <div className="flex items-center justify-between">
        <span className="font-bold cursor-pointer">
          All Product{count > 1 && "s"}
          {count && `(${count})`}
        </span>
        <span className="flex gap-3">
          <button
            onClick={() => setActive("list")}
            className={`rounded-md px-[13px] ${
              active === "list" ? "text-orange bg-[#FFF5F0]" : ""
            }`}
          >
            <Icon2 />
          </button>
          <button
            onClick={() => setActive("box")}
            className={`text-[#414141] rounded-md  p-[13px] ${
              active === "box" ? "text-orange bg-[#FFF5F0]" : ""
            }`}
          >
            <Icon1 />
          </button>
        </span>
      </div>
    </div>
  );
};

export default Header;

const Icon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
      />
    </svg>
  );
};

const Icon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
      />
    </svg>
  );
};
